import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import {CoachRankMonthBox} from '/component/base/BonusProgressBar/CoachRankMonthBox';
import Icon from '/component/base/Icon/Icon';
import Text from '/component/base/Text';
import {IncentiveTrip} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {getMonthName} from '../IncentiveTripBanner.util';

import {styles} from './Requirements.style';
import {CoachRankProps, RankAchievement} from './Requirements.types';

export const CoachRank = ({
  iconColor,
  rankAchievements,
  coachGoalRank,
  path,
  currentDate,
  showIncentiveUpdate,
}: CoachRankProps) => {
  const {ts} = useTranslation('requirements.coachGoalRank');
  const {description = ''} = coachGoalRank;

  const isQualified = showIncentiveUpdate
    ? rankAchievements?.filter(({status}: any) => status).length >= 1
    : rankAchievements?.filter(({status}: any) => status).length >= 2;

  const currentMonth = getMonthName(currentDate);

  const boxesArray: any = [];

  const currentMonthIndex = rankAchievements?.findIndex(
    (item: RankAchievement) => {
      const achievementDate = new Date(item.date);
      const newCurrentDate = currentDate ? new Date(currentDate) : null;

      if (
        newCurrentDate &&
        achievementDate.getFullYear() === newCurrentDate.getFullYear()
      ) {
        return currentMonth === getMonthName(achievementDate);
      }
      return false;
    },
  );

  rankAchievements?.map((rankAchievement: any, i: any) => {
    const rankAchievementStatus = get(rankAchievement, 'status', false);
    const rankAchievementDate = new Date(get(rankAchievement, 'date', null));
    if (i < currentMonthIndex) {
      if (rankAchievementStatus) {
        boxesArray.push({
          isChecked: true,
          month: getMonthName(rankAchievementDate),
        });
      } else {
        boxesArray.push({
          noStyle: true,
          isLineThrough: true,
          month: getMonthName(rankAchievementDate),
        });
      }
    } else if (i === currentMonthIndex && rankAchievementStatus) {
      boxesArray.push({
        isChecked: true,
        month: getMonthName(rankAchievementDate),
      });
    } else if (i === currentMonthIndex && !rankAchievementStatus) {
      boxesArray.push({
        isChecked: false,
        month: getMonthName(rankAchievementDate),
      });
    } else {
      boxesArray.push({
        noStyle: true,
        month: getMonthName(rankAchievementDate),
      });
    }
  });

  const renderDescription = () => {
    const requirement = showIncentiveUpdate ? 'once' : 'twice';
    let rankDescription = '';
    if (path === 2) {
      rankDescription = ts(
        'coachRankDescriptionPath2',
        `Qualify as ${description} with two qualifying Senior Coaches ${requirement}:`,
      );
    } else {
      rankDescription = ts(
        `coachRankDescriptionPath${path}`,
        `Qualify as ${description} ${requirement}:`,
      );
    }
    return rankDescription;
  };

  return (
    <View {...testProperties(IncentiveTrip.itQualifyAsRankView, true)}>
      <View
        style={styles.progressBarContainer}
        {...testProperties(IncentiveTrip.itQualifyAsRank, true)}>
        <Icon
          name={isQualified ? 'circle-checkmark-filled' : 'circle'}
          style={{
            ...styles.circleCheckMarkIcon,
            color: iconColor,
            ...(isQualified
              ? styles.circleCheckedFilledFont
              : styles.circleUnFilledFont),
          }}
          testID={
            IncentiveTrip.itQualifyAsRankGoalCheckbox +
            `-${!isQualified ? 'un' : ''}checked`
          }
        />
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="caption"
          style={styles.coachDescription}
          {...testProperties(IncentiveTrip.itQualifyAsRankLablel)}>
          {renderDescription()}
        </Text>
      </View>
      <View
        style={
          showIncentiveUpdate
            ? styles.boxesContainerUpdate
            : styles.boxesContainer
        }>
        {boxesArray?.map(
          // @ts-expect-error TS(7031): Binding element 'isChecked' implicitly has an 'any... Remove this comment to see the full error message
          ({isChecked, month, isLineThrough, noStyle}, index) => (
            <CoachRankMonthBox
              isChecked={isChecked}
              month={month}
              isLineThrough={isLineThrough}
              noStyle={noStyle}
              key={index}
              showIncentiveUpdate={showIncentiveUpdate}
            />
          ),
        )}
      </View>
    </View>
  );
};
